export const SET_CACHE = "SET_CACHE";
export const SET_FRAME = "SET_FRAME";
export const RESET = "RESET";

export const setDashboardSliderCache = (payload) => ({
  type: SET_CACHE,
  payload: payload
});

export const setDashboardSliderFrame = (payload) => ({
  type: SET_FRAME,
  payload: payload
});

export const resetDashboardSlider = () => ({
  type: RESET
});